import {
  Action,
  CallOutCoverageData,
  CallOutCoverageQueryParams,
  ShiftsResponse as Response,
  ShiftData,
  ShiftQueryParams,
  convertCallOutCoverage,
  convertScheduleChangeToShiftData,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import scheduleKeys from 'schedule/queries/shared/keys'
import { performAction } from 'shared/queries/perform_action'
import keys from './shared/keys'

type Variables = Action

// FIXME: make queryParam a required parameter so we can update cache properly

export function usePerformShiftAction(queryParams?: ShiftQueryParams) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: mutateShift,
    onSuccess: async data => {
      if (data && queryParams) {
        const key = keys.detail(queryParams)

        if (client.getQueryData<ShiftData>(key)) {
          await client.cancelQueries({ queryKey: key })
          client.setQueryData<ShiftData>(key, data)
        }
      }

      // FIXME: only invalidate affected shifts
      client
        .invalidateQueries({ queryKey: keys.all })
        .catch(err => console.error(err))
      client
        .invalidateQueries({ queryKey: scheduleKeys.all })
        .catch(err => console.error(err))
    },
  })

  async function mutateShift(action: Variables): Promise<ShiftData | null> {
    const response = await performAction<Response.ScheduleChange>(
      server,
      action
    )
    return response ? convertScheduleChangeToShiftData(response) : null
  }
}

export function usePerformCallOutAction(
  queryParams: CallOutCoverageQueryParams
) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: mutateCallOutCoverage,
    onSuccess: async data => {
      if (data && queryParams) {
        const key = keys.callout(queryParams)
        if (client.getQueryData<CallOutCoverageData>(key)) {
          await client.cancelQueries({ queryKey: key })
          client.setQueryData<CallOutCoverageData>(key, data)
        }
      }
      client
        .invalidateQueries({ queryKey: keys.all })
        .catch(err => console.error(err))
      client
        .invalidateQueries({ queryKey: scheduleKeys.all })
        .catch(err => console.error(err))
    },
  })

  async function mutateCallOutCoverage(
    action: Variables
  ): Promise<CallOutCoverageData | null> {
    const response = await performAction<Response.CallOutCoverageData>(
      server,
      action
    )

    return response ? convertCallOutCoverage(response) : null
  }
}
